// Vue
import {createApp} from 'vue';

// Vuetify
import {vuetify} from '@/plugins/vuetify';

// FontAwesome
import {library} from '@fortawesome/fontawesome-svg-core';
import {faSalesforce} from '@fortawesome/free-brands-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

// Our project code
import ExternalApp from './ExternalApp.vue';
import {initializeStore} from './store';
import config from 'firebaseConfig'; // webpack alias for firebaseConfig-development.json or firebaseConfig-production.json
import {initializeFirebase, onAuthStateChanged, auth} from '@/services/FirestoreService';
import {initialize as initializeFlags} from '@/services/FlagService';
import {MapService} from '@/services/MapService';
import {initialize as initEventService} from '@/services/EventService';
import {getStore, registerStore} from '@/services/store';
import router from './router';
import {Concealments} from '@/services/ConcealmentService';

library.add(faSalesforce);

// Firebase must be initialized before any other Firestore functions are called.
initializeFirebase(config);

const store = initializeStore();
// Register the store with the store service so that it can be accessed from outside of Vue components.
registerStore(store);
const app = createApp(ExternalApp).use(store).use(vuetify).use(router).component('Fa', FontAwesomeIcon);

// This config is necessary to set to prevent a warning when using a reactive provide/inject.
// https://github.com/vuejs/core/blob/49023549257d8962c6e059808067b1b67b398534/packages/runtime-core/src/componentOptions.ts#L666
// According to the warning, this will eventually be the default behavior and this line can be removed.
app.config.unwrapInjectedRef = true;

// Attach the app to the window object for ease of testing and debugging.
if (process.env.NODE_ENV === 'development') {
  window.app = app;
  window.MapService = MapService;
}

initEventService();
initializeFlags({}); // initialize empty default, will get updated if user exists
await Concealments.createMapConcealments();
app.mount('#app');

onAuthStateChanged(auth, async (user) => {
  if (!user) return;
  try {
    const token = await user.getIdTokenResult(true);
    await initializeFlags(token.claims);
  } catch (error) {
    error.message = `Error getting custom claims or initializing flags: ${error.message}`;
    console.error(error);
  }
  try {
    await getStore().dispatch('startSessionDebugging', {collection: 'app-config'});
  } catch (error) {
    error.message = `Error starting session debugging: ${error.message}`;
    console.error(error);
  }
});
